<div class="cSmartMedia" *ngIf="ImageData.View === 'R'; else expandedview;">
  <div class="manik-loading-shade" *ngIf="FormSubmitted">
    <mat-spinner></mat-spinner>
  </div>
  <ng-template [ngTemplateOutlet]="ChooseMediaType"></ng-template>
  <ng-template [ngTemplateOutlet]="EditImage"></ng-template>
  <ng-template [ngTemplateOutlet]="EditIcon"></ng-template>
  <ng-template [ngTemplateOutlet]="EditYouTube"></ng-template>
  <ng-template [ngTemplateOutlet]="EditVideo"></ng-template>
  <ng-template [ngTemplateOutlet]="EditSliderMedia"></ng-template>
  <ng-template [ngTemplateOutlet]="EditSolidColor"></ng-template>
  <ng-template [ngTemplateOutlet]="EditImageAttributes"></ng-template>
  <ng-template [ngTemplateOutlet]="Pattern"></ng-template>
  <ng-template [ngTemplateOutlet]="SubmitSmartMedia"></ng-template>
</div>
<ng-template #expandedview>
  <div class="cSmartMedia" *ngIf="ImageData.View === 'E'; else ExpandedSliderView;">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-5">
          <ng-template [ngTemplateOutlet]="ChooseMediaType"></ng-template>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <ng-template [ngTemplateOutlet]="EditImage"></ng-template>
          <ng-template [ngTemplateOutlet]="EditIcon"></ng-template>
          <ng-template [ngTemplateOutlet]="EditYouTube"></ng-template>
          <ng-template [ngTemplateOutlet]="EditVideo"></ng-template>
          <ng-template [ngTemplateOutlet]="EditSliderMedia"></ng-template>
          <ng-template [ngTemplateOutlet]="EditSolidColor"></ng-template>
          <ng-template [ngTemplateOutlet]="Pattern"></ng-template>
          <ng-template [ngTemplateOutlet]="SubmitSmartMedia"></ng-template>
        </div>
        <div class="col-md-6" *ngIf="EditProperties">
          <ng-template [ngTemplateOutlet]="EditProperty"></ng-template>
        </div>
        <div class="col-md-6" *ngIf="Settings">
          <ng-template [ngTemplateOutlet]="EditImageAttributes"></ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #EditProperty>
  <form [formGroup]="MediaPropertyForm">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="form-group">
        <div class="cDefault">
          <h5>Header <span>*</span></h5>
          <input formControlName="Header" type="text">
        </div>
      </div>
      <div class="form-group">
        <div class="cDefault">
          <h5>Sub Header <span>*</span></h5>
          <input formControlName="SubHeader" type="text">
        </div>
      </div>
      <div class="form-group">
        <div class="cDefault">
          <h5>Description</h5>
          <textarea formControlName="Description"></textarea>
        </div>
      </div>
    </div>
  </form>
</ng-template>
<ng-template #EditImageAttributes>
  <form *ngIf="Settings">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="cTransparency">
        <div class="row">
          <div class="col-lg-4">
            <div class="cOpacityText">Opacity</div>
          </div>
          <div class="col-lg-8">
            <div class="cOpacityInput">
              <mat-slider thumbLabel="true" (input)="onSliderChange($event, 'T')" name="Transparency"
                [(value)]="SMediaModel.Transparency" tickInterval="1" min="0" step="0.1" max="1">
              </mat-slider>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="cTransparency select">
        <div class="row">
          <div class="col-lg-4">
            <div class="cOverlayText">Overlay</div>
          </div>
          <div class="col-lg-8">
            <div class="cOverlayInput">
              <mat-radio-group aria-label="Overlay" [(ngModel)]="Overlay" (change)="onSliderChange($event, 'O');"
                name="Overlay">
                <mat-radio-button [value]="'Y'">Yes</mat-radio-button>
                <mat-radio-button [value]="'N'">No</mat-radio-button>
              </mat-radio-group>
              <div *ngIf="UseOverlay">
                <div class="cTransparency"></div>
                <div class="row">
                  <div class="col-lg-4">
                    <div>Pattern</div>
                  </div>
                  <div class="col-lg-8">
                    <div class="cMatdd_main">
                      <div class="dropdown cPatternDDParent">
                        <button class="btn btn-default dropdown-toggle" type="button" id="Pattern"
                          data-toggle="dropdown">
                          <img [src]="SMediaModel.ImgEditPatternURL"
                            style="height: 50px !important; width: 50px !important;" />
                          <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu cPatternDD" role="menu" aria-labelledby="Pattern">
                          <li role="presentation" *ngFor="let tmp of PatternList"
                            (click)="onSliderChange(tmp.PatternURL, 'P');"><a role="menuitem" tabindex="-1"
                              href="javascript:void(0);">
                              <img [src]="tmp.PatternURL" [alt]="tmp.PatternURL" />
                            </a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cTransparency"></div>
                <div class="row">
                  <div class="col-lg-4">
                    <div class="cColorText">Color</div>
                  </div>
                  <div class="col-lg-8">
                    <div class="cDefault cColorInput"><input name="favcolor" value="#ff0000"
                        [(ngModel)]="SMediaModel.OpacityColor" (change)="onSliderChange(SMediaModel.OpacityColor, 'C');"
                        type="color">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="cTransparency select">
        <div class="row">
          <div class="col-lg-4">
            <div class="cZindexText">Z-index</div>
          </div>
          <div class="col-lg-8">
            <div class="cMatdd_main">
              <mat-select placeholder="Choose an option" [(value)]="ZIndexSelectedValue"
                (selectionChange)="onSliderChange($event, 'Z');">
                <mat-option *ngFor="let item of ZIndex" [value]="item.DataValue">{{item.DataText}}</mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-template [ngTemplateOutlet]="EditProperty" *ngIf="EditProperties"></ng-template>
</ng-template>
<ng-template #EditImage>
  <div *ngIf="SMediaModel.MediaType === 'I'">
    <div class="cSmartMediaBox">

      <div class="cSmartMediaImg">

        <div >
          <!-- <style>.cSmartMedia_overlay:before{
          width:100%;
          height:100%;
          content:"";
          position:absolute;
          z-index: 1;
          background-color:red;
          
          opacity: 0.3;
          background: url(SMediaModel.ImageURL);         
          
          }</style> -->
          <img id="MediaImage" [src]="SMediaModel.ImageURL" />
          </div>

        <!-- <img id="MediaImage" [src]="SMediaModel.ImageURL" /> -->
        <div [ngStyle]="ImgEdit.AppliedStyle"></div>
      </div>
      <ng-template [ngTemplateOutlet]="SmartMediaActionButtons"></ng-template>
    </div>
  </div>
</ng-template>
<ng-template #EditIcon>
  <div *ngIf="SMediaModel.MediaType === 'C'">
    <!-- <div class="cSmartMediaIconContainer">
      <span class="cSmartMediaIcon"><i [ngClass]="SMediaModel.IconText"></i></span>
      <input type="button" name="btnSubmitCustom" value="Change Icon" [iconPicker]="icon" class="cSmartMediaChooseIcon"
        [ipPosition]="'bottom'" [ipWidth]="'250px'" [ipPlaceHolder]="'Choose an icon'"
        [ipFallbackIcon]="SMediaModel.IconText" [ipIconPack]="'fa'" (iconPickerSelect)="onIconPickerSelect($event)" />
    </div> -->
  </div>
</ng-template>
<ng-template #EditYouTube>
  <div *ngIf="SMediaModel.MediaType === 'Y'">
    <div class="cDefault">
      <iframe [src]="SMediaModel.YoutubeURL | Youtube" frameborder="0" allowfullscreen></iframe>
      <h5>Youtube VideoURL</h5>
      <input type="text" [(ngModel)]="SMediaModel.YoutubeURL" (change)="GenerateEmbedYoutubeURL();" />
    </div>
  </div>
</ng-template>
<ng-template #EditVideo>
  <div *ngIf="SMediaModel.MediaType === 'V'">
    <div class="cSmartMediaBox">
      <div class="cSmartMediaImg">

        <div >
          <!-- <style>.cSmartMedia_overlay:before{
          width:100%;
          height:100%;
          content:"";
          position:absolute;
          z-index: 1;
          background-color:red;
          
          opacity: 0.3;
         
          
          }</style> -->
           <video controls="controls" width="320" height="240" id="rvideo">
            <source [src]="SMediaModel.VideoURL" type="video/mp4" />
            <source [src]="SMediaModel.VideoURL" type="video/webm" />
            <source [src]="SMediaModel.VideoURL" type="video/ogg" />
          </video>
          </div>


      
      </div>
      <ng-template [ngTemplateOutlet]="SMVideoActionButtons"></ng-template>
    </div>
  </div>
</ng-template>
<ng-template #ExpandedSliderView>
  <!-- <ng-template [ngTemplateOutlet]="EditSliderInExpandedView"></ng-template> -->
</ng-template>
<ng-template #EditSliderMedia>
  <div *ngIf="SMediaModel.MediaType === 'S' || SMediaModel.MediaType === 'F'" id="resource">
    <ng-template [ngTemplateOutlet]="sliderimglistings"></ng-template>

    <div *ngIf="SMediaModel.SliderMediaType === 'I'">
      <div class="cSmartMediaBox">
        <div class="cSmartMediaImg">

          <div >
            <!-- <style>.cSmartMedia_overlay:before{
            width:100%;
            height:100%;
            content:"";
            position:absolute;
            z-index: 1;
            background-color:red;
            
            opacity: 0.3;
            background: url(http://resources.manikworks.com/portal/empay/arches.png);
            
            
            }</style> -->
             <img id="SliderImageURLRegular" [src]="SMediaModel.SliderImageURL" />
            </div>
          
          <!-- <img id="SliderImageURLRegular" [src]="SMediaModel.SliderImageURL" /> -->
          <div [ngStyle]="ImgEdit.AppliedStyle"></div>
        </div>
        <ng-template [ngTemplateOutlet]="SmartMediaActionButtons"></ng-template>
      </div>
    </div>

    <div *ngIf="SMediaModel.SliderMediaType === 'Y'">
      <div class="cSmartMediaBox">
        <div class="cSmartMediaImg">
          <iframe width="320" height="240" [src]="SMediaModel.SliderYoutubeURL | Youtube" frameborder="0"
            allowfullscreen></iframe>
          <h5>Youtube VideoURL</h5>
          <input type="text" [(ngModel)]="SMediaModel.SliderYoutubeURL" (change)="GenerateEmbedYoutubeURL('S');" />
        </div>
        <ng-template [ngTemplateOutlet]="SmartMediaActionButtons"></ng-template>
      </div>
    </div>

    <div *ngIf="SMediaModel.SliderMediaType === 'V'">
      <div class="cSmartMediaBox">
        <div class="cSmartMediaImg">
          <video controls="controls" width="320" height="240" id="sVideo1">
            <source [src]="SMediaModel.SliderVideoURL" type="video/mp4" />
            <source [src]="SMediaModel.SliderVideoURL" type="video/webm" />
            <source [src]="SMediaModel.SliderVideoURL" type="video/ogg" />
          </video>
          <ng-template [ngTemplateOutlet]="SMVideoActionButtons"></ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #EditSolidColor>
  <div *ngIf="SMediaModel.MediaType === 'O'">
    <div class="cDefault">
      Choose Color &nbsp;
      <input type="color" [(ngModel)]="SMediaModel.SolidColor" />
    </div>
  </div>
</ng-template>
<ng-template #Pattern>
  <div *ngIf="SMediaModel.MediaType === 'P'">
    <div class="cMatdd_main">
      <h5>Select Pattern </h5>
      <div class="dropdown cPatternDDParent">
        <button class="btn btn-default dropdown-toggle" type="button" id="Pattern" data-toggle="dropdown">
          
          <img [src]="SMediaModel.PatternURL" />
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu cPatternDD" role="menu" aria-labelledby="Pattern">
          <li role="presentation" (click)="onSliderChange('', 'P');"><a role="menuitem" tabindex="-1"
              href="javascript:void(0);">
              None
            </a></li>
          <li role="presentation" *ngFor="let tmp of PatternList" (click)="onSliderChange(tmp.PatternURL, 'P');"><a
              role="menuitem" tabindex="-1" href="javascript:void(0);">
              <img [src]="tmp.PatternURL" [alt]="tmp.PatternURL" />
            </a></li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #ChooseMediaType>
  <div class="cMatdd_main">
    <div class="row">
      <div class="col-lg-5">
        <h5>Media Type</h5>
      </div>
      <div class="col-lg-7">
        <mat-select placeholder="Select Media Type" [ngModel]="SMediaModel.MediaType"
          (selectionChange)="OnMediaTypeChange($event.value)">
          <mat-option *ngFor="let item of MediaType" [value]="item.DataValue">{{item.DataText}}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #sliderimglistings>
  <div class="cSMSliderMain" *ngIf="SMediaModel.MediaType === 'S' || SMediaModel.MediaType === 'F'">
    <div class="cSMSlider">
      <angular-image-slider class="image-cropper" *ngIf="SliderImages.length" id="grid" (click)="GetImage($event);"
        [images]="SliderImages">
      </angular-image-slider>
    </div>
    <div class="cSMAddNew">
      <button class="cAdd" (click)="AddNewSliderMedia();"></button>
    </div>
  </div>
  <div *ngIf="SMediaModel.AddNewSliderMedia && (SMediaModel.MediaType === 'S' || SMediaModel.MediaType === 'F')">
    <mat-radio-group [(ngModel)]="SMediaModel.SliderMediaType">
      <mat-radio-button *ngFor="let item of SliderMediaType" [value]="item.DataValue">
        {{item.DataText}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</ng-template>
<ng-template #SmartMediaActionButtons>
  <div class="cSMActionButtons" *ngIf="SMediaModel.SliderMediaType !== 'Y' && SMediaModel.MediaType !== 'Y'">
    <div class="cSMUpload">
      <label for="file-input299"><span class="fa fa-upload"></span></label>
      <input *ngIf="SMediaModel.MediaType === 'I'" id="file-input299" type="file" accept='image/*'
        (change)="imgPreview($event,'MediaImage', 1)">
      <input
        *ngIf="((SMediaModel.MediaType === 'S' || SMediaModel.MediaType === 'F') && SMediaModel.SliderMediaType === 'I')"
        id="file-input299" type="file" accept='image/*' (change)="imgPreview($event,'SliderImageURLRegular', 1)">
    </div>
    <div class="cSMEdit" (click)="EditProperties=!EditProperties; Settings=false;" *ngIf="ImageData.ShowEditOptions">
      <span id="cBtn1" class="fa fa-text-width"></span>
    </div>
    <div class="cSMSettings" (click)="Settings=!Settings; EditProperties=false" *ngIf="ImageData.ShowEditOptions">
      <span id="cBtn2" class="fa fa-cog" aria-hidden="true"></span>
    </div>
    <div class="cSMDelete" *ngIf="SMediaModel.SliderMediaID" (click)="DeleteSliderMedia(SMediaModel.SliderMediaID);">
      <span id="cBtnDeleteMedia" class="fa fa-trash" aria-hidden="true"></span>
    </div>
    <div class="cSMDelete">
      <span id="cBtnDeleteMedia" class="fa fa-bolt" aria-hidden="true"></span>
    </div>
  </div>
</ng-template>
<ng-template #SMVideoActionButtons>
  <div class="cSMActionButtons">
    <div class="cSMUpload">
      <label for="file-input298"><span class="fa fa-upload" aria-hidden="true"></span></label>
      <input *ngIf="(SMediaModel.MediaType === 'S' || SMediaModel.MediaType === 'F')" accept='video/*' id="file-input298"
        type="file" (change)="videoSetup($event, 1,'jkj', 'sVideo1');">
      <input *ngIf="SMediaModel.MediaType === 'V'" id="file-input298" type="file" accept='video/*'
        (change)="videoSetup($event, 1,'jkj', 'rvideo');">
    </div>
    <div class="cSMEdit" (click)="EditProperties=!EditProperties; Settings=false;" *ngIf="ImageData.ShowEditOptions">
      <span id="cBtn1" class="fa fa-text-width" aria-hidden="true"></span>
    </div>
    <div class="cSMSettings" (click)="Settings=!Settings; EditProperties=false" *ngIf="ImageData.ShowEditOptions">
      <span id="cBtn2" class="fa fa-cog" aria-hidden="true"></span>
    </div>
    <div class="cSMDelete" *ngIf="SMediaModel.SliderMediaID" (click)="DeleteSliderMedia(SMediaModel.SliderMediaID);">
      <span id="cBtnDeleteMedia" class="fa fa-trash" aria-hidden="true"></span>
    </div>
  </div>
</ng-template>
<ng-template #SubmitSmartMedia>
   <div class="col-lg-12"><!--*ngIf="ImageData.ShowSubmitButton"> -->
    <div class="cFormButton" (click)="SubmitToDatabase();">
      <i></i> Save Media Settings
    </div>
  </div>
</ng-template>